<div class="container">
    <div class="row no-gutters">
        <div class="col-12">

            <div class="d-flex popup-head align-items-center">

                <div class="popup-title mr-auto pl-4" *ngIf="modelFlag === 'add'" translate>lblAddTargetedGroup</div>
                <div class="popup-title mr-auto pl-4" *ngIf="modelFlag === 'edit'" translate>lblEditTargetedGroup</div>
                <div class="popup-title mr-auto pl-4" *ngIf="modelFlag === 'view'" translate>lblViewTargetedGroup</div>
                <div class="float-right">
                    <a class="close mr-3" (click)="OnClose()" translate>
                        <span class="" aria-hidden="true">&times;</span>
                    </a>
                </div>

            </div>

            <div class="scrollbar">
                <div class="card-content">
                    <div class="">
                        <div class="row" [formGroup]="targetedGroupform">
                            <div class="col-6">
                                <label for="service" translate>lblName
                                    <strong class="mlt6 required"> * </strong> </label>
                                <input type="text" formControlName="name" class="form-control mb-1">
                                <div *ngIf="cf.name.touched && cf.name.errors" class="help-block text-danger mb-3">
                                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                                        translate>lblTargetedGroupNameIsRequired</span>
                                </div>
                            </div>
                            <div class="col-6 ">
                                <label for="service" translate>lblDescription</label>
                                <textarea class="form-control mb-3" formControlName="description"></textarea>
                            </div>
                        </div>
                        <div class="">
                            <label for="service" translate>lblQueryBuilder
                                <strong class="mlt6 required"> * </strong> </label>
                            <div class="relative">
                                <div class="d-flex align-items-center">
                                    <div class="flex-grow-1">
                                        <query-builder [formControl]='queryCtrl' [classNames]='classNames'
                                            [config]='config' [allowRuleset]='true' [allowCollapse]='true'>
                                        </query-builder>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="requiredQuery" class="help-block text-danger">
                                <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                                    translate>lblAtleastOneQueryRequired</span>
                            </div>
                            <div *ngIf="!validQuery" class="help-block text-danger">
                                <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                                    translate>lblQueryIsNotValid</span>
                            </div>
                        </div>


                        <!--View Customer-->
                        <div class="my-2 text-right">
                            <button type="button" class="btn btn-primary nowrap" (click)="getCampaignMembers(true)">
                                <em class="fas fa-eye"></em> <span translate>lblViewCustomer</span>
                            </button>
                            <button type="button" class="ml-2" (click)="exportAsXLSX(documentTypes.Excel)"
                                ngbTooltip="{{'lblExportExcel' | translate}}" *ngIf="showCustomer" placement="bottom"
                                aria-label="Center Align">
                                <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
                            </button>
                            <button class="ml-2 btn btn-outline-primary" (click)="clear()">
                                <em class="fas fa-sync fa-lg"></em>
                            </button>
                        </div>

                        <div class="row no-gutters" *ngIf="showCustomer">
                            <div class="col-md-12">
                                <div class="">
                                    <div id="scrollDiv" class="table-responsive max-370" infinite-scroll
                                        [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
                                        [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                                        <table class="tablest1">
                                            <thead class="stick-header">
                                                <tr>
                                                    <th scope="col" style="width: 30px;">#</th>
                                                    <th scope="col" sortable="Name" (sort)="onSort($event)" translate>
                                                        lblName</th>
                                                    <th scope="col" sortable="Email" (sort)="onSort($event)" translate>
                                                        lblEmail</th>
                                                    <th scope="col" translate>lblMobile</th>
                                                    <th class="text-center" sortable="City" (sort)="onSort($event)"
                                                        scope="col" translate>lblCity</th>
                                                    <th class="text-center" scope="col" translate>lblEmailConsent</th>
                                                    <th class="text-center" scope="col" translate>lblSMSConsent</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngIf="campaignMembers?.length > 0; else load_else">
                                                    <tr *ngFor="let member of campaignMembers; let i = index">
                                                        <td>{{ i+1 }}</td>
                                                        <td>{{ member.name }}</td>
                                                        <td>{{ member.email }}</td>
                                                        <td>{{ member.mobile }}</td>
                                                        <td class="text-center">{{ member.city }}</td>
                                                        <td class="text-center">{{ member.emailConsent }}</td>
                                                        <td class="text-center">{{ member.smsConsent }}</td>
                                                    </tr>
                                                </ng-container>
                                                <ng-template #load_else>
                                                    <tr>
                                                        <td colspan="12" class="no-record" translate>
                                                            lblNoRecordsFound
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="card-footer">
                                        <div class="d-flex justify-content-between">
                                            <div class="d-flex justify-content-between p-2 font17 fontbold"
                                                style="margin: auto 0;">
                                                <span class="font17 fontnormal"
                                                    translate>lblTotal</span>:&nbsp;{{totalCount}}&nbsp;<span
                                                    class="font17 fontnormal" translate>lblResults</span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-3 bg-light pp-footer-top-brdr">
                <div class="row">
                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                        <button type="submit" (click)="saveandNext()" [disabled]="targetedGroupform.invalid"
                            class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" translate><em
                                class="far fa-save font16 align-top mr-2"></em> lblSaveChanges</button>
                        <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em
                                class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>